<template>
   <Layout>
      <div class="row">
         <div class="col-12">
            <div class="page-title-box d-flex align-items-center justify-content-between">
               <h4 class="mb-0 font-size-18">Listado de Clientes</h4>
            </div>
         </div>
      </div>
      <div class="row">
         <div class="col-lg-12">
            <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-4">Clientes por Zona {{ zoneSelected }}</h4>
                  <load-spinner v-if="loading"></load-spinner>
                  <customers-list v-else :customers="customers" />
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>

<script>
   import Layout from "@/layouts/Main"
   import LoadSpinner from '@/components/widgets/LoadSpinner'
   import CustomersList from "@/components/widgets/CustomersList"
   import axios from 'axios'

   export default {
      name: 'Customers-List',
      data() {
         return {
            completeCustomerList: [ ],
            loading: true
         }
      },
      components: {
         Layout, LoadSpinner, CustomersList
      },
      computed: {
         zoneSelected() {
            return this.$store.state.user.selectedZone
         },
         customers() {
            return this.completeCustomerList.filter(zone => zone.repre == this.zoneSelected)
         }
      },
      async created() {
         let zonas = this.$store.state.user.zones
         let params = "json="+JSON.stringify({ zonas })
          
         await axios({url: 'https://portal.asein.es/api-v2/cargar-clientes', data: params, method: 'POST' })
         .then(resp => {
            this.completeCustomerList = resp.data
            this.loading = false
         })
         .catch(err => {
            console.log(err)
         })
      }
   }
</script>
